import React, { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import InputField from "../../admin/childComponents/inputComponents/InputField";
import TextArea from "../../admin/childComponents/inputComponents/TextArea";
import CAPTCHATurnStile from "../../admin/childComponents/appComponents/CAPTCHATurnStile";
import Loading from "../../admin/childComponents/appComponents/Loading";
import "../../../assets/css/ContactSection.css";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const initialFormData = {
  input: {
    names: "",
    email: "",
    mobile: "",
    subject: "",
  },
  textArea: {
    textMessage: "",
  },
};

function ContactSection() {
  const [loading, setLoading] = useState(false);
  const [reCaptcha, setReCaptcha] = useState(false);
  const [formData, setFormData] = useState(initialFormData);

  const updateFormData = (type, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  const refreshScreen = () => {
    setFormData({
      input: { ...initialFormData.input },
      textArea: { ...initialFormData.textArea },
    });
    setReCaptcha(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (loading || !reCaptcha) return;

    setLoading(true);
    const formPayload = new FormData();
    formPayload.append("names", formData.input.names.trim());
    formPayload.append("email", formData.input.email.trim());
    formPayload.append("mobile", formData.input.mobile.trim());
    formPayload.append("subject", formData.input.subject.trim());
    formPayload.append("textMessage", formData.textArea.textMessage.trim());
    formPayload.append("typeRequest", "FOI");

    try {
      await axios.get("/sanctum/csrf-cookie");
      const res = await axios.post(`${BASE_URL}fbdata`, formPayload);

      if (res.data.status === 200) {
        swal(
          "Message Sent",
          res.data.message ||
            "Thank you for contacting the Ministry. Your message has been received.",
          "success",
        );
        refreshScreen();
      } else {
        swal(
          "Unable to Send",
          res.data.message || "Please review your details and try again.",
          "error",
        );
      }
    } catch (error) {
      console.error("Contact form submission failed:", error);
      swal(
        "Submission Failed",
        "We could not send your message. Please try again later.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="fmw-contact section">
      <div className="container">
        <header className="fmw-contact-heading" data-aos="fade-up">
          <span className="fmw-contact-eyebrow">
            Federal Ministry of Works
          </span>
          <h2>Get in Touch With Us</h2>
          {/* <p>
            Have a question, request, or feedback? Send us a message and the appropriate
            team will be able to review your enquiry.
          </p> */}
        </header>

        <div
          className="fmw-contact-grid"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <aside className="fmw-contact-information">
            <div className="fmw-contact-info-intro">
              <span className="fmw-contact-kicker">Get in touch</span>
              <h3>Contact the Ministry</h3>
              {/* <p>Reach out through the contact details below or use the enquiry form.</p> */}
            </div>

            <div className="fmw-contact-info-item">
              <span className="fmw-contact-icon" aria-hidden="true">
                <i className="fa fa-map-marker-alt" />
              </span>
              <div>
                <h4>Visit Us</h4>
                <p>Federal Ministry of Works</p>
                <p>Headquarters, Mabushi, Abuja, Nigeria</p>
              </div>
            </div>

            <div className="fmw-contact-info-item">
              <span className="fmw-contact-icon" aria-hidden="true">
                <i className="fa-solid fa-phone" />
              </span>
              <div>
                <h4>Call Us</h4>
                <p>Nigeria: 234-(0)- 8 061 7433 13</p>
                <p className="fmw-contact-muted">
                  Monday to Friday, 8:00 a.m. – 4:00 p.m.
                </p>
              </div>
            </div>

            <div className="fmw-contact-info-item">
              <span className="fmw-contact-icon" aria-hidden="true">
                <i className="fa-solid fa-envelope" />
              </span>
              <div>
                <h4>Email Directory</h4>
                <p>
                  <a href="mailto:info@fmw.gov.ng">info@fmw.gov.ng</a>
                  <span>General enquiries</span>
                </p>
                <p>
                  <a href="mailto:registryhm@fmw.gov.ng">
                    registryhm@fmw.gov.ng
                  </a>
                  <span>Minister’s Registry</span>
                </p>
                <p>
                  <a href="mailto:registryhms@fmw.gov.ng">
                    registryhms@fmw.gov.ng
                  </a>
                  <span>Minister of State</span>
                </p>
                <p>
                  <a href="mailto:registryops@fmw.gov.ng">
                    registryops@fmw.gov.ng
                  </a>
                  <span>Permanent Secretary</span>
                </p>
                <p>
                  <a href="mailto:registryfmw@fmw.gov.ng">
                    registryfmw@fmw.gov.ng
                  </a>
                  <span>FMW Registry</span>
                </p>
              </div>
            </div>

            <div className="fmw-contact-map-wrap">
              <div className="fmw-contact-map-caption">
                <i className="fa fa-location-dot" aria-hidden="true" />
                <span>Find our headquarters</span>
              </div>
              <iframe
                title="Map showing the Federal Ministry of Works headquarters"
                src="https://www.google.com/maps?q=Federal%20Ministry%20of%20Works%2C%20Mabushi%2C%20Abuja&output=embed"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </aside>

          <div className="fmw-contact-form-panel">
            <div className="fmw-contact-form-heading">
              <span className="fmw-contact-kicker">Online enquiry</span>
              <h3>Send Us a Message</h3>
              {/* <p>Fields marked with an asterisk (*) are required.</p> */}
            </div>

            <form onSubmit={handleSubmit} className="fmw-contact-form">
              <div className="fmw-contact-form-grid">
                <div className="fmw-contact-field fmw-contact-field-full">
                  <InputField
                    label="Full Name"
                    name="names"
                    size="14"
                    required="required"
                    value={formData.input.names}
                    type="text"
                    onChange={updateFormData}
                  />
                </div>
                <div className="fmw-contact-field">
                  <InputField
                    label="Email Address"
                    name="email"
                    size="14"
                    required="required"
                    value={formData.input.email}
                    type="email"
                    onChange={updateFormData}
                  />
                </div>
                <div className="fmw-contact-field">
                  <InputField
                    label="Phone Number"
                    name="mobile"
                    size="14"
                    required="required"
                    value={formData.input.mobile}
                    type="tel"
                    onChange={updateFormData}
                  />
                </div>
                <div className="fmw-contact-field fmw-contact-field-full">
                  <InputField
                    label="Subject"
                    name="subject"
                    size="14"
                    required="required"
                    value={formData.input.subject}
                    type="text"
                    onChange={updateFormData}
                  />
                </div>
                <div className="fmw-contact-field fmw-contact-field-full">
                  <TextArea
                    label="Message"
                    name="textMessage"
                    size="14"
                    rows={7}
                    required="required"
                    value={formData.textArea.textMessage}
                    onChange={updateFormData}
                  />
                </div>
              </div>

              <div className="fmw-contact-captcha">
                <CAPTCHATurnStile
                  reCaptcha={reCaptcha}
                  setReCaptcha={setReCaptcha}
                />
              </div>

              <div className="fmw-contact-submit-row">
                <p>
                  <i className="fa fa-shield-halved" aria-hidden="true" /> Your
                  information is submitted securely.
                </p>
                <button type="submit" disabled={!reCaptcha || loading}>
                  {loading ? (
                    <>
                      <span
                        className="fmw-contact-spinner"
                        aria-hidden="true"
                      />{" "}
                      Sending…
                    </>
                  ) : (
                    <>
                      Send Message{" "}
                      <i className="fa fa-arrow-right" aria-hidden="true" />
                    </>
                  )}
                </button>
              </div>
              {!reCaptcha && (
                <p className="fmw-contact-captcha-note">
                  Please complete the security verification before sending your
                  message.
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default React.memo(ContactSection);
